import { render, staticRenderFns } from "./msg.vue?vue&type=template&id=24d17ca0&"
import script from "./msg.vue?vue&type=script&lang=ts&"
export * from "./msg.vue?vue&type=script&lang=ts&"
import style0 from "./msg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports